import React, { useRef, useEffect, useState } from 'react';
import { Draggable } from '@fullcalendar/interaction';
import { Paper, Typography, Avatar, Box, Stack, Collapse, IconButton, FormGroup, FormControlLabel, Checkbox, Button, Dialog } from '@mui/material';
import { Edit, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import Task from './WorkorderView/Task';



const TaskList = ({ taskData,open,handleOpen,selectedTask,handleSelect,workOrderDetail,handleRefresh }) => {

const [mode,setMode]=useState("")
const [addTask,setAddTask]=useState(false)
const [editData,setEditData]=useState({})

  const handleAddTask=()=>{
   setMode("create")
   setAddTask(true)

  }

  const handleCloseClick=()=>{
    setMode("")
    setAddTask(false)
    setEditData({})
    handleRefresh(workOrderDetail.id)
  }

  return (
    <Box
      sx={{
        width: 350,
        // maxHeight: '50vh',
        // overflowY: 'auto',
        p: 2,
        borderRadius: 2,
        border: '1px solid #ddd',
      }}
    >
     <Box sx={{display:"flex",gap:"0.5rem",alignItems:"center",cursor:"pointer"}} onClick={handleOpen}>
      <Typography variant="h6" fontWeight={600} gutterBottom  >
       {workOrderDetail.name} Task List 
       
      </Typography>
       {open?<KeyboardArrowUp/>:<KeyboardArrowDown/>}
      </Box>
      
      <Collapse in={open} sx={{maxHeight: '50vh',
        overflowY: 'auto',}}>
          <Button sx={{width:"100%",mb:"1rem"}} variant='contained' onClick={handleAddTask}>Add Task</Button>
      <FormGroup onChange={handleSelect}>
      {taskData.map((event) => (
        <Paper
              variant="outlined"
              sx={{
                p: "0.2rem 1rem",
                mb: 1,
                borderRadius: 2,
                // backgroundColor: event.backgroundColor || 'primary.main',
                color: "black",
                borderLeft: `4px solid ${event.borderColor || "#1976d2"}`, // Left border highlight
                boxShadow: "none",
                userSelect: "none",
                display:"flex",
                alignItems:"center",
                justifyContent:"space-between"
              }}
              data-event-id={event.id}
              data-all-day={event.isAllDay}
            >
              {/* <Stack direction="row" spacing={2} alignItems="flex-start">
             
                <Box>
                  <Typography fontWeight={500}>{event.title}</Typography>
                </Box>
              </Stack> */}
             
          <FormControlLabel
            control={
              <Checkbox checked={selectedTask.includes(event.id)}  value={event.id} />
            }
            label={event.taskName}
            sx={{
                '& .MuiFormControlLabel-label': { // Target the label element
                whiteSpace:"break-spaces"
                },
              }}
          />
          <IconButton onClick={()=>{
             setMode("Edit")
    setAddTask(true)
    setEditData(event)
          }}>
            <Edit/>
          </IconButton>
            </Paper>
      ))}
      </FormGroup>
      </Collapse>
      <Dialog
        open={addTask}
        onClose={handleCloseClick}
       PaperProps={{
    sx: {
      maxWidth: '90vw', // set max width in viewport width
      width: '100%',     // optional, ensures it can grow to max
    }
  }}
        children={<Task handleCloseClick={handleCloseClick} workOrderId={workOrderDetail.id} editData={editData} mode={mode}  />}
      />
    </Box>
  );
};

export default TaskList;
